import { BaseEdge, BezierEdgeProps, EdgeLabelRenderer, Position, useReactFlow, Edge as EdgeType, EdgeProps } from "@xyflow/react"
import { getEdgePath } from "./flow.utils"
import { ActionIcon } from "@mantine/core"
import { useState } from "react"
import { cn } from "@/lib/utils"
import { store } from "@/stores/stores"

// this is a little helper component to render the actual edge label
function EdgeLabel({ transform, label }: { transform: string; label: string }) {
  return (
    <div
      style={{
        position: "absolute",
        background: "transparent",
        padding: 3,
        color: "#ff5050",
        borderRadius: 50,
        fontSize: 12,
        fontWeight: 500,
        transform,
        backgroundColor: "var(--ground)",
      }}
      className="nodrag nopan"
    >
      {label}
    </div>
  )
}

export type BaseEdgeType = EdgeType<{}, "default">

function Edge({
  id,
  sourceX,
  sourceY,
  targetX,
  targetY,
  sourcePosition = Position.Bottom,
  targetPosition = Position.Top,
  label,
  labelStyle,
  labelShowBg,
  labelBgStyle,
  labelBgPadding,
  labelBgBorderRadius,
  style,
  markerEnd,
  markerStart,
  pathOptions,
  data,
  interactionWidth,
}: EdgeProps) {
  const { setEdges } = useReactFlow()
  const [edgeHovered, setEdgeHovered] = useState(false)
  const [btnHovered, setBtnHovered] = useState(false)
  const [mousePos, setMousePos] = useState<{ x: number; y: number } | null>(null)
  const { screenToFlowPosition } = useReactFlow()

  const hovered = store.scenario.editing.hoveringEdge || btnHovered

  const [path, labelX, labelY] = getEdgePath(
    {
      sourceX: sourceX,
      sourceY: sourceY,
      sourcePosition: sourcePosition,
      targetX: targetX,
      targetY: targetY,
      targetPosition: targetPosition,
    },
    { edge: true },
  )

  const onEdgeClick = () => {
    setEdges((edges) => edges.filter((edge) => edge.id !== id))
    store.scenario.editing.hoveringEdge = false
  }

  return (
    <>
      <BaseEdge
        id={id}
        path={path}
        labelX={labelX}
        labelY={labelY}
        label={label}
        labelStyle={labelStyle}
        labelShowBg={labelShowBg}
        labelBgStyle={{
          borderRadius: 50,
        }}
        labelBgPadding={labelBgPadding}
        labelBgBorderRadius={labelBgBorderRadius}
        // style={{ ...style, stroke: hovered ? style?.stroke : undefined, "--xy-edge-stroke": hovered ? style?.stroke : undefined }}
        style={{
          ...style,
          "--xy-edge-stroke": hovered ? style?.color : "inherit",
          "--xy-edge-label-color": "var(--handle-unconnected-error)",
          // strokeDasharray: 6,
          // "--xy-edge-stroke": style?.color,
          // opacity: hovered ? 1 : 0.6,
        }}
        // style={style}
        markerEnd={markerEnd}
        markerStart={markerStart}
        interactionWidth={interactionWidth}
      ></BaseEdge>
      <path
        d={path}
        fill="none"
        stroke={style?.color}
        opacity={hovered ? 0.2 : 0}
        className="transition-opacity duration-300"
        radius={50}
        strokeWidth={20} // Área maior para detectar hover
        onMouseEnter={() => {
          setEdgeHovered(true)
          store.scenario.editing.hoveringEdge = true
        }}
        onMouseLeave={() => {
          setEdgeHovered(false)
          store.scenario.editing.hoveringEdge = false
        }}
        onClick={() => {
          onEdgeClick()
        }}
        // onMouseMove={(event) => setMousePos({ x: event.clientX, y: event.clientY })}
      />
      <EdgeLabelRenderer>
        {!!data?.startLabel && <EdgeLabel transform={`translate(-50%, -50%) translate(${labelX}px,${labelY}px)`} label={data.startLabel} />}
      </EdgeLabelRenderer>
      <div
        className={cn(
          `
            fixed nodrag nopan z-[10] origin-center opacity-100

            hover:opacity-100
          `,
          hovered && "opacity-100",
        )}
        style={{
          pointerEvents: "all",
          top: mousePos?.y,
          left: mousePos?.x,
          // transform: `translate(-50%, -50%) translate(${mousePos?.x}px,${mousePos?.y}px)`,
        }}
      >
        <ActionIcon
          color="dark"
          className={`
            z-10 rounded-full bg-background shadow-lg

            hover:bg-base-hover
          `}
          variant={"subtle"}
          size={"sm"}
          // style={
          //   btnHovered
          //     ? {
          //         backgroundColor: style?.color,
          //         color: "white",
          //       }
          //     : {}
          // }
          style={{
            backgroundColor: style?.color,
            color: "white",
          }}
          type="button"
          onClick={onEdgeClick}
          onMouseEnter={() => setBtnHovered(true)}
          onMouseLeave={() => setBtnHovered(false)}
        >
          <IconIconamoonSignTimesFill className="size-6" />
        </ActionIcon>
      </div>
    </>
  )
}

export default Edge
